/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Backoffice API Gateway
 * OpenAPI spec version: 1.0.0
 */
import type {
  CreateDirectDebitRequest,
  CreateDirectDebitResponse,
  SuggestedPaymentResponse,
} from "../model"

import { backofficeRequest } from "../../client"

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1]

/**
 * @summary Create a direct debit
 */
export const createDirectDebit = (
  accountId: number,
  createDirectDebitRequest: CreateDirectDebitRequest,
  options?: SecondParameter<
    typeof backofficeRequest<CreateDirectDebitResponse>
  >,
) => {
  return backofficeRequest<CreateDirectDebitResponse>(
    {
      url: `/accounts/${accountId}/direct_debit`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: createDirectDebitRequest,
    },
    options,
  )
}
/**
 * @summary Fetches information for nova to display recommended options for payment amounts in direct debits
 */
export const fetchSuggestedPayment = (
  billingAccountId: number,
  options?: SecondParameter<typeof backofficeRequest<SuggestedPaymentResponse>>,
) => {
  return backofficeRequest<SuggestedPaymentResponse>(
    {
      url: `/accounts/${billingAccountId}/fetch_suggested_payment`,
      method: "GET",
    },
    options,
  )
}
export type CreateDirectDebitResult = NonNullable<
  Awaited<ReturnType<typeof createDirectDebit>>
>
export type FetchSuggestedPaymentResult = NonNullable<
  Awaited<ReturnType<typeof fetchSuggestedPayment>>
>
